import { regions } from "@/components/staticFiles/stateLookup.js"
import { listStates } from "@/components/staticFiles/stateLookup.js"
import { listmonths } from '@/components/staticFiles/months.js'

// header background image
export function getbkUrl(month,state) {

    let stateval = (state == 'Select a State') ? 'CA' : (listStates.find( ({ desc }) => desc == state )).value
    let monthval = (month == 'Any Month') ? 9 : (listmonths.find( ({ desc }) => desc == month )).value
    
    let imagepath = require.context('@/assets/img/bg/', false, /\.jpg$/)
    let dimension = ['-544x667.jpg','-768x550.jpg','-992x550.jpg','-1200x550.jpg','-1920x550.jpg']
    let region =  (state == "Select a State" || state == "" || state == null) ? "southeast" : regions[stateval]
    let season = month == 'Any Month' ? 'summer' : (monthval <= 4 || monthval == 23 || monthval == 24) ? "winter" : (monthval >= 5 && monthval <= 10) ? "spring" : (monthval >= 11 && monthval <= 16) ? "summer" : "fall"
    // let season = (monthval <= 4 || monthval == 23 || monthval == 24) ? "winter" : (monthval >= 5 && monthval <= 10) ? "spring" : (monthval >= 11 && monthval <= 16) ? "summer" : "fall"
    return imagepath('./' + region + '-' + season + dimension[4])
}

export function getImgUrl(veg) {
    // let dimension = "-350x184.jpg";
    // dimension = isMobile ? "-350x184.jpg" : "-190x100.jpg";
    let imagepath = require.context('@/assets/img/veg/', false, /\.jpg$/)
    return imagepath('./' + veg + "-350x184.jpg")
}

export function toURL(veg) {
    if (!veg || veg.length == 0 || veg == 'Select a State') {
        return 'southern-california'
    } else if (!veg || veg.length == 0 || veg == 'Any Month') {
        return 'early-may'
    } else {
        return veg.toString().replace(/ /g,"-").toLowerCase()
    }
}

export function toURLm(veg) {
    if (!veg || veg.length == 0 || veg == 'Any Month') {
        return 'early-may'
    } else {
        return veg.toString().replace(/ /g,"-").toLowerCase()
    }
}

export function toURLreverse (veg) {
    if (veg && veg != 'washington-dc') {
        return veg.replace(/-/g," ").replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();})
    } else if (veg == 'washington-dc') {
        return 'Washington DC'
    }
}